import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { getRecentListens } from '../lib/lastfm';
import { getAlbumImage } from 'web-shared/src/types/lastfm';

export class RecentListens extends HTMLElement {
  constructor() {
    super();
  }

  render = async () => {
    this.innerHTML = '';
    this.append(<skeleton-loader width="100%" height="250px" />);

    const recentListenResult = await getRecentListens();
    if (recentListenResult.isErr()) {
      console.error(recentListenResult.error);
      this.innerHTML = '';
      this.append(
        <div>
          <p>An error occurred when fetching albums</p>
          <code>{JSON.stringify(recentListenResult.error, null, 2)}</code>
        </div>,
      );

      return;
    }

    const recentListenValue = recentListenResult.value;
    const albums = recentListenValue.topAlbums
      .filter((album) => parseInt(album.playcount || '0') > 2)
      .sort(
        (a, b) => parseInt(b.playcount || '0') - parseInt(a.playcount || '0'),
      );

    this.innerHTML = '';
    this.append(
      <div class="recommendations">
        {...albums.map((album) => (
          <album-artwork
            name={album.name}
            artist={album.artist.name}
            artwork={getAlbumImage(album.image)}
          />
        ))}
      </div>,
    );
  };

  connectedCallback() {
    void this.render();
  }
}
